import { render, staticRenderFns } from "./KeyKeeperSticker.vue?vue&type=template&id=48395a7e&scoped=true&"
import script from "./KeyKeeperSticker.vue?vue&type=script&lang=ts&"
export * from "./KeyKeeperSticker.vue?vue&type=script&lang=ts&"
import style0 from "./KeyKeeperSticker.vue?vue&type=style&index=0&id=48395a7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48395a7e",
  null
  
)

export default component.exports